export default () => {
    refreshCheckoutButtons();
    document.querySelector("#dynamic-delivery").addEventListener("change", () => setTimeout(refreshCheckoutButtons, 500));
};

const shouldPreventCheckout = () => {
    const checkEl:HTMLInputElement = document.querySelector("input[name='DisableCheckout']");

    if (checkEl) {
        return checkEl.value == "true";
    }
    return false;
};

let counter = 0;
const refreshCheckoutButtons = () => {
    if (counter > 20) {
        counter = 0;
        return;
    }

    const deliveryPanel = document.getElementById("dynamic-delivery");
    const guestCheckout = document.querySelector("a[href='/checkout/details?guest=true']");
    const secureCheckout = document.querySelector("a[href='/checkout/']");

    const allCheckoutButtons = [guestCheckout, secureCheckout];

    allCheckoutButtons.forEach(button => {
        if (button != null) button.classList.remove("disabled");
    });

    if (deliveryPanel.classList.contains("is-loading")) {
        setTimeout(() => refreshCheckoutButtons(), 200);
        counter++;
        return;
    } else if (shouldPreventCheckout()) {
        allCheckoutButtons.forEach(button => {
            button.classList.add("disabled");
        });
    }

    counter = 0;
};

